<template>
  <div class="item">
    <img v-if="iconurl" class="icon" :src="iconurl" alt="">
    <span class="item-title">{{title}}</span>
    <span class="item-value">{{value}}</span>
  </div>
</template>
<script>
export default {
  name: 'detail_item',
  props: ['iconurl', 'title', 'value']
}
</script>
<style lang="scss" scoped>
.item {
  font-size: .3rem;
  display: -webkit-flex;
  display: flex;
  min-height: .90rem;
  align-items: center;
  .icon {
    width: .38rem;
    height: .29rem;
    margin-right: .28rem;
  }
  .item-title {
    width: 2.4rem;
  }
  .item-value {
    text-align: right;
    flex: 1;
    font-size: .28rem;
    color:rgba(51, 51, 51, .6);
  }
}
</style>



// WEBPACK FOOTER //
// src/components/detail_item.vue